import { Box, InputAdornment, InputLabel, TextField } from "@mui/material";
import classNames from "classnames";
import React, { forwardRef, memo } from "react";
import styles from "./Input.module.scss";
import { combineClasses } from "utils/utils";
import { ReactComponent as SearchIcon } from "assets/Icons/SearchIcon.svg";

const Input = ({
  required,
  inputLabel,
  searchable = false,
  roundedMobile = false,
  disabledSx = {},
  ...props
}) => {
  return (
    <span>
      {inputLabel && (
        <InputLabel
          className={combineClasses(styles.inputLabel, props?.labelStyle)}
        >
          {inputLabel}{" "}
          <span className={styles.mandatory1}>{required ? "*" : ""}</span>
        </InputLabel>
      )}

      <TextField
        {...props}
        autoComplete="new-password"
        sx={{
          // width: `${props.width !== "" ? `${props.width}px` : "100%"}`,
          width: props.width ? props.width : "100%",
          "& input": {
            padding: `${
              searchable
                ? "0.5rem 0.5rem 0.5rem 0px !important"
                : "0.5rem 1rem !important"
            }`,
          },

          "& input::placeholder": {
            fontSize: "14px",
            fontFamily: "'DM Sans',Arial",
            fontWeight: "300 !important",
            color: "#AEB2E3",
            opacity: 1,
          },
          // ✅ Added: conditional border-radius below 500px
          ...(roundedMobile && {
            "@media (max-width: 500px)": {
              "& .MuiOutlinedInput-root": {
                borderRadius: "24px !important",
              },
            },
          }),
          // ✅ Added: conditional disabled styles
          ...(props.disabled && {
            "& .MuiOutlinedInput-root.Mui-disabled": {
              ...disabledSx,
            },
          }),
        }}
        InputProps={{
          ...(searchable && {
            startAdornment: (
              <InputAdornment
                position="start"
                sx={{
                  marginRight: 1,
                  marginLeft: 0,
                  padding: 0,
                  minHeight: "unset",
                }}
              >
                <SearchIcon className={styles.searchIcon} />
              </InputAdornment>
            ),
          }),
        }}
        size="small"
        fullWidth={props?.fullWidth ?? true}
        error={props?.invalid}
        placeholder={props?.placeholder}
        className={classNames(
          styles?.inputContainer,
          searchable && styles.searchableField,
          props.className,
        )}
      />
    </span>
  );
};

export default memo(Input);
